import { useNavigate } from "react-router-dom";
import Contact from "../component/Contact";
import { Link } from "react-scroll";
import { useState } from "react";
import EnquiryPopup from "../component/EnquiryPopup";

const Footer = () => {
  const navigate = useNavigate();
  const [enquiryOpen, setEnquiryOpen] = useState(false);

  return (
    <>
      {/*  <Contact /> */}
      <div className=" w-screen bg-[#242124] overflow-y-hidden mt-[10%] ">
        <div className=" text-white mt-20 relative">
          <div
            className="hidden md:flex flex-col justify-center items-center mt-[5%] "
            id="black-section"
          >
            <div className="w-[90%] max-w-[1440px]">
              {/*   <div
                className="flex mt-[5%] gap-3 cursor-pointer items-center"
                onClick={() => {
                  navigate("/");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              >
                <div className="w-10 h-10">
                  <img
                    src="/assets/angle right b.svg"
                    className="w-full h-auto object-cover"
                    alt="arrow"
                  />
                </div>
                <span className="text-[32px] font-clash font-normal -mt-1">
                  Back to top
                </span>
              </div> */}

              {/* Footer Info */}
              <div className="flex justify-between mt-[5%] gap-10">
                {/* Left Column: Contact Info */}
                <div className="flex flex-col gap-5">
                  {/* Email */}
                  <div>
                    <h4 className="font-clash font-normal text-[24px] text-[#DDDDDD] leading-7">
                      Email
                    </h4>
                    <a
                      href="https://mail.google.com/mail/?view=cm&fs=1&to=info@azerotech.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      className=" font-aileron font-normal text-[18px] text-white leading-7 cursor-pointer"
                    >
                      info@azerotech.com
                    </a>
                  </div>

                  {/* Phone */}
                  <div>
                    <h4 className="font-clash font-normal text-[24px] text-[#DDDDDD] leading-7">
                      Phone
                    </h4>
                    <a
                      href="tel:+919363959787"
                      className=" font-aileron font-normal text-[18px] text-white leading-7 cursor-pointer"
                    >
                      +91 9363 95 9787
                    </a>
                  </div>

                  {/* Address */}
                  <div className="max-w-sm">
                    <h4 className="font-clash font-normal text-[24px] text-[#DDDDDD] leading-7 mb-1">
                      Address
                    </h4>
                    <a
                      href="https://maps.app.goo.gl/vxYZmwGp58E74tGK9"
                      target="_black"
                    >
                      <p className=" font-aileron font-normal text-[18px] text-white leading-relaxed cursor-pointer">
                        Kangayanellore Rd, <br />
                        Viruthampattu, Vellore,
                        <br /> Tamil Nadu 632006
                      </p>
                    </a>
                    {/* <p className="font-aileron font-normal text-[18px] text-white leading-relaxed">
                      Kangayanellore Rd, <br />
                      Viruthampattu, Vellore, <br />
                      Tamil Nadu 632006
                      <br />
                    </p> */}
                  </div>
                </div>

                {/* Middle Column: CTA */}
                <div className="flex flex-col gap-5 mt-10">
                  <h1 className="font-clash font-normal text-[28px] text-white leading-none">
                    Let’s explore ways to <br />
                    increase efficiency
                  </h1>

                  <div
                    className="flex gap-2  mt-5 items-center bg-[linear-gradient(to_right,#FB1E01_0%,#FB1E01_50%,white_100%)] bg-clip-text text-transparent font-medium text-[28px] font-clash cursor-pointer "
                    onClick={() => setEnquiryOpen(!enquiryOpen)}
                  >
                    Talk to an Expert
                    <img src="/assets/arrow up right.svg" alt="arrow" />
                  </div>
                </div>

                {/* Right Column: Logos + Social */}
                <div className="mt-10 flex flex-col gap-5">
                  <div className="flex gap-2 items-center">
                    <img src="/assets/azero-white.svg" alt="azero-white" />
                    <img
                      src="/assets/azero-logo-white.svg"
                      className="mt-1"
                      alt="azero-logo"
                    />
                  </div>

                  <p className="text-[16px] font-aileron text-white max-w-[320px]">
                    Make your data invisible by generating unlimited identities.
                    The next-level in privacy protection for online and travel.
                  </p>

                  <div className="flex gap-4 mt-4">
                    <a
                      target="_black"
                      href="https://in.linkedin.com/company/azero-tech"
                    >
                      <img
                        className="hover:scale-110 transition w-7 h-7"
                        src="/assets/linked.svg"
                        alt="linked"
                      />
                    </a>

                    <a
                      target="_black"
                      href="https://www.instagram.com/azero_tech/reels/"
                    >
                      <img
                        className="hover:scale-110 transition w-7 h-7"
                        src="/assets/insta.svg"
                        alt="insta"
                      />
                    </a>
                    <a
                      target="_black"
                      href="https://www.facebook.com/Azerotechsol/"
                    >
                      <img
                        className="hover:scale-110 transition w-7 h-7"
                        src="/assets/facebook.svg"
                        alt="facebook"
                      />
                    </a>

                    <a target="_black" href="https://x.com/Azerotech">
                      <img
                        className="hover:scale-110 transition w-7 h-7"
                        src="/assets/Twitter → SVG.svg"
                        alt="twitter"
                      />
                    </a>
                  </div>
                </div>
              </div>
              <div className="w-full relative mt-[5%]">
                <img
                  src="/assets/AZERO TECH.svg"
                  alt="Azero Tech"
                  className="w-full h-auto object-contain  pointer-events-none"
                />

                <div className="absolute inset-0 flex flex-col md:flex-row items-center justify-between gap-4 text-white text-sm px-4 md:px-10 py-4">
                  <span className="font-clash font-normal text-[18px]">
                    Copyright © AzeroTech 2026
                  </span>
                  <span className="font-clash font-normal text-[18px]">
                    We respect your privacy
                  </span>
                  <span className="font-clash font-normal text-[18px]">
                    All Rights Reserved
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer
          className=" md:hidden w-full bg-[#242124] px-4 py-10 text-white flex flex-col gap-10 md:px-20"
          id="black-section"
        >
          {/*   <div
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => {
              navigate("/");
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <div className="w-10 h-10">
              <img
                src="/assets/angle right b.svg"
                alt="Back to top"
                className="w-full h-auto"
              />
            </div>
            <span className="text-lg font-clash font-normal">Back to top</span>
          </div> */}

          <div className="flex flex-col gap-10 md:flex-row justify-between">
            <div className="flex flex-col gap-4 md:w-1/3">
              <div>
                <h4 className="font-clash text-base text-[#DDDDDD]">Email</h4>
                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=info@azerotech.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" font-aileron font-normal text-white leading-7 cursor-pointer"
                >
                  info@azerotech.com
                </a>
              </div>
              <div>
                <h4 className="font-clash text-base text-[#DDDDDD]">Phone</h4>
                <a
                  href="tel:+919363959787"
                  className=" font-aileron font-normal  text-white leading-7 cursor-pointer"
                >
                  +91 9363 95 9787
                </a>
              </div>
              <div>
                <h4 className="font-clash text-base text-[#DDDDDD]">Address</h4>
                <a
                  href="https://maps.app.goo.gl/vxYZmwGp58E74tGK9"
                  target="_black"
                >
                  <p className=" font-aileron font-normal  text-white leading-relaxed cursor-pointer">
                    Kangayanellore Rd, <br />
                    Viruthampattu, Vellore,
                    <br /> Tamil Nadu 632006
                  </p>
                </a>
              </div>
            </div>

            <div className="flex flex-col gap-3 md:w-1/3">
              <h1 className="font-clash text-lg leading-snug md:text-xl">
                Let’s explore ways to <br /> increase efficiency
              </h1>
              {/*  <span className="bg-gradient-to-r from-[#FB1E01] to-white bg-clip-text text-transparent font-medium font-clash text-lg md:text-xl">
                Consult with our experts
              </span> */}
              <div
                className="flex items-center gap-2 text-base md:text-lg mt-1 bg-gradient-to-r from-[#FB1E01]  bg-clip-text text-transparent cursor-pointer"
                onClick={() => setEnquiryOpen(!enquiryOpen)}
              >
                Talk to an Expert
                <img
                  src="/assets/arrow up right.svg"
                  alt="arrow"
                  className="w-4 h-4 md:w-5 md:h-5"
                />
              </div>
            </div>

            <div className="flex flex-col gap-4 md:w-1/3">
              <div className="flex items-center gap-2">
                <img
                  src="/assets/azero-white.svg"
                  alt="Azero"
                  className="w-8 h-auto"
                />
                <img
                  src="/assets/azero-logo-white.svg"
                  alt="Azero Logo"
                  className="w-24 h-auto"
                />
              </div>
              <p className=" text-[14px] text-[#FFFFFF] font-aileron font-normal">
                Make your data invisible by generating unlimited identities. The
                next-level in privacy protection for online and travel.
              </p>
              <div className="flex gap-4 mt-2">
                <a
                  target="_black"
                  href="https://in.linkedin.com/company/azero-tech"
                >
                  <img
                    className="hover:scale-110 transition-transform w-6 h-6"
                    src="/assets/linked.svg"
                    alt="LinkedIn"
                  />
                </a>

                <a
                  target="_black"
                  href="https://www.instagram.com/azero_tech/reels/"
                >
                  <img
                    className="hover:scale-110 transition-transform w-6 h-6"
                    src="/assets/insta.svg"
                    alt="Instagram"
                  />
                </a>

                <a
                  target="_black"
                  href="https://www.facebook.com/Azerotechsol/"
                >
                  <img
                    className="hover:scale-110 transition-transform w-6 h-6"
                    src="/assets/facebook.svg"
                    alt="Facebook"
                  />
                </a>
                <a target="_black" href="https://x.com/Azerotech">
                  <img
                    className="hover:scale-110 transition-transform w-6 h-6"
                    src="/assets/Twitter → SVG.svg"
                    alt="Twitter"
                  />
                </a>
              </div>
            </div>
          </div>

          <div className="w-full mt-5">
            <img
              src="/assets/AZERO TECH.svg"
              alt="Azero Tech"
              className="w-full h-auto object-contain"
            />
          </div>

          <div className="mt-5 border-t border-white/20 pt-5 flex flex-col md:flex-row justify-center items-center  md:justify-between gap-2 text-sm md:text-base">
            <span className="font-clash">Copyright © AzeroTech 2026</span>
            <span className="font-clash">We respect your privacy</span>
            <span className="font-clash">All Rights Reserved</span>
          </div>
        </footer>
      </div>
      {enquiryOpen && <EnquiryPopup onClose={() => setEnquiryOpen(false)} />}
    </>
  );
};

export default Footer;
